$(document).ready(function()
{

	var _toggle_buttons =  '.toggle-button';
	//var _toggle_displays =  '.toggle-display';

	$( _toggle_buttons ).each(function () 
	{
		$( this ).click(function (e) 
		{
			e.preventDefault();

			$( this ).toggleClass('active');

			if ( $( this ).data( 'display' ) )
			{
				var display_name = $( this ).data( 'display' );
				$( ('#' + display_name) ).toggleClass('active');				
			}
			else
			{
				$( this ).closest( ".toggle-display" ).toggleClass( "active" );
			}

		});
	});

});